// extracted by mini-css-extract-plugin
module.exports = {"block-quote":"block-quote_block-quote__8jbvu","block-quote__arrow":"block-quote_block-quote__arrow__ZBr7W"};